export class EventStatus {
  static PENDING = 'pending';
  static DONE = 'done';
  static FAILED = 'failed';
}
